import React, { useState } from "react";
import "./Contact.css";
import { motion } from "framer-motion";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaInstagramSquare } from "react-icons/fa";

const ContactForm = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

  };


  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);


    const formData = new FormData();


    formData.append(
      "access_key",
      "6120fc0f-c436-48c3-8d0f-9d0530bce243"
    );


    formData.append(
      "name",
      form.name
    );


    formData.append(
      "email",
      form.email
    );


    formData.append(
      "message",
      form.message
    );


    formData.append(
      "subject",
      "New Contact Form Submission - Vedastra Technologies"
    );


    formData.append(
      "from_name",
      "Vedastra Website"
    );


    formData.append(
      "replyto",
      form.email
    );


    // Web3Forms spam protection
    formData.append(
      "botcheck",
      ""
    );


    try {


      const response = await fetch(
        "https://api.web3forms.com/submit",
        {
          method: "POST",
          body: formData,
        }
      );


      const result = await response.json();


      console.log(result);



      if(result.success){


        alert(
          "Message sent successfully!"
        );


        setForm({

          name:"",
          email:"",
          message:""

        });


      }
      else{


        alert(
          "Failed to send message"
        );


      }



    }
    catch(error){


      console.log(error);

      alert(
        "Something went wrong!"
      );


    }


    setLoading(false);

  };



  return (

    <div className="backdiv">


      <section className="contact2-wrapper">



        {/* LEFT SIDE */}


        <div className="contact2-left">


          <motion.div

          initial={{
            opacity:0,
            x:-80
          }}

          animate={{
            opacity:1,
            x:0
          }}

          transition={{
            duration:0.6
          }}

          >



          <h2 className="main-title">
            Let’s Talk.
          </h2>



          <p className="main-text text-center">

            We build scalable digital products,
            AI systems, and high-performing
            web experiences.

          </p>




          <div className="contact2-info">


            <p>
              📍 Noida, India
            </p>


            <p>
              📧 info@vedastratechnologies.com
            </p>


            <p>
              📞 +91 76683 84694
            </p>


          </div>





          <div className="contact2-socials">



            <a

            href="https://wa.me/917668384694"

            target="_blank"

            rel="noopener noreferrer"

            >

            <IoLogoWhatsapp />

            </a>




            <a

            href="https://www.instagram.com/vedastra5"

            target="_blank"

            rel="noopener noreferrer"

            >

            <FaInstagramSquare />

            </a>



          </div>



          </motion.div>



        </div>






        {/* FORM SIDE */}



        <motion.div

        className="contact2-right"

        initial={{
          opacity:0,
          x:80
        }}

        animate={{
          opacity:1,
          x:0
        }}

        transition={{
          duration:0.6
        }}

        >



        <form

        className="form-card"

        onSubmit={handleSubmit}

        >



        <input

        type="hidden"

        name="subject"

        value="New Contact Form Submission"

        />



        <input

        type="hidden"

        name="redirect"

        value="false"

        />





        <div className="form-group">


        <input

        type="text"

        name="name"

        value={form.name}

        required

        onChange={handleChange}

        />


        <label>
          Full Name
        </label>


        </div>







        <div className="form-group">


        <input

        type="email"

        name="email"

        value={form.email}

        required

        onChange={handleChange}

        />


        <label>
          Email Address
        </label>


        </div>







        <div className="form-group">


        <textarea

        name="message"

        rows="4"

        value={form.message}

        required

        onChange={handleChange}

        ></textarea>



        <label>
          Message
        </label>



        </div>







        <button

        className="form-btn"

        type="submit"

        disabled={loading}

        >


        {
          loading
          ?
          "Sending..."
          :
          "Send Request →"
        }


        </button>





        </form>



        </motion.div>




      </section>



    </div>

  );

};


export default ContactForm;